import * as React from 'react'

import { 
  CHECKBOX_MULTI_ICON, 
  CLOCK_ICON, 
  ELL_ADVANCED_SCREENSHOT, 
  ELL_INTERMEDIATE_SCREENSHOT, 
  ELL_STARTER_SCREENSHOT, 
  STARTER_DIAGNOSTIC_SCREENSHOT,
  INTERMEDIATE_DIAGNOSTIC_SCREENSHOT,
  ADVANCED_DIAGNOSTIC_SCREENSHOT,
  GRADUATION_CAP_ICON, 
  TOOL_DIAGNOSTIC_BORDERED 
} from '../asset_constants'

const STARTER = 'Starter'
const INTERMEDIATE = 'Intermediate'
const ADVANCED = 'Advanced'

const ellLevelToScreenshot = {
  [STARTER]: ELL_STARTER_SCREENSHOT,
  [INTERMEDIATE]: ELL_INTERMEDIATE_SCREENSHOT,
  [ADVANCED]: ELL_ADVANCED_SCREENSHOT
}

const levelToScreenshot = {
  [STARTER]: STARTER_DIAGNOSTIC_SCREENSHOT,
  [INTERMEDIATE]: INTERMEDIATE_DIAGNOSTIC_SCREENSHOT,
  [ADVANCED]: ADVANCED_DIAGNOSTIC_SCREENSHOT
}

const ellProficiencyLevelToData = {
  [STARTER]: {
    description: 'For newcomer and beginner English learners',
    skills: ['Articles', 'Plurals', 'Possessives', 'Pronouns', 'Adjectives', 'Adverbs', 'And more'],
    timeEstimate: '20 - 40 mins'
  },
  [INTERMEDIATE]: {
    description: 'For students needing help with tenses',
    skills: ['Subject-verb agreement', 'Prepositions', 'Future tense', 'Questions', 'And more'],
    timeEstimate: '20 - 35 mins'
  },
  [ADVANCED]: {
    description: 'For advanced English learners',
    skills: ['Reflexive pronouns', 'Gerunds', 'Infinitives', 'Commonly confused words', 'And more'],
    timeEstimate: '20 - 40 mins'
  }
}

const proficiencyLevelToData = {
  [STARTER]: {
    description: 'For secondary students needing a refresher or elementary students learning basics',
    skills: ['Plurals', 'Possesives', 'Capitalization', 'Subject-verb agreement', 'Pronouns', 'Commonly confused words'],
    timeEstimate: '30 - 40 mins'
  },
  [INTERMEDIATE]: {
    description: 'For students who completed the Starter Diagnostic or students ready to build complex sentences',
    skills: ['Compound parts of speech', 'Appositives', 'Compound and complex sentences', 'Conjunctive adverbs'],
    timeEstimate: '30 - 40 mins'
  },
  [ADVANCED]: {
    description: 'For students who completed the Intermediate Diagnostic, or are skilled in compound/complex sentence writing',
    skills: ['Relative clauses', 'Appositive phrases', 'Participial phrases', 'Parallel structure', 'Open sentence combining'],
    timeEstimate: '30 mins'
  }
}

const ProficiencyLevelColumn = ({ ell, level }) => {
  const { description, skills, timeEstimate } = ell ? ellProficiencyLevelToData[level] : proficiencyLevelToData[level] ;

  return (
    <section aria-labelledby={`proficiency-heading-${level}`} className="proficiency-column">
      <div>
        <h2 id={`proficiency-heading-${level}`}>
          <img alt="" src={TOOL_DIAGNOSTIC_BORDERED} />
          <span>{ell && <React.Fragment>ELL <br /></React.Fragment>}{level}</span>
        </h2>
        <img alt={`Screenshot of the student interface in the ${ell ? 'ELL ' : ''}${level} Quill Diagnostic activity`} className="screenshot" src={ell ? ellLevelToScreenshot[level] : levelToScreenshot[level]} />
        <p className="proficiency-level-description">
          <img alt="" src={GRADUATION_CAP_ICON} />
          <span className="sr-only">Description: </span>
          {description}
        </p>
        <div className="proficiency-level-skills">
          <img alt="" src={CHECKBOX_MULTI_ICON} />
          <span className="sr-only">Skills: </span>
          <ul>
            {skills.map((skill, index) => (
              <li key={index}>{skill}</li>
            ))}
          </ul>
        </div>
      </div>
      <p className="proficiency-level-time-estimate">
        <img alt="" src={CLOCK_ICON} />
        <span className="sr-only">Time estimate: </span>
        {timeEstimate}
      </p>
    </section>
  );
};

const ChooseTheProficiencyLevelSlide = ({ slideGroupClassName, ell, }) => (
  <section className={`slide ${slideGroupClassName} choose-the-proficiency-level-slide`} key="choose-the-proficiency-level-slide">
    <div>
      <h1>Choose the proficiency level best for your students</h1>
      <div className="flex-wrapper">
        <div className="top-level-information">
          <p><span>Available in</span><b> 3 </b><span>proficiency levels</span></p>
          <p><span>That assess</span><b> 21 </b><span>language skills</span></p>
        </div>
        <div className="proficiency-level-column-wrapper">
          <ProficiencyLevelColumn ell={ell} level={STARTER} />
          <ProficiencyLevelColumn ell={ell} level={INTERMEDIATE} />
          <ProficiencyLevelColumn ell={ell} level={ADVANCED} />
        </div>
      </div>
    </div>
  </section>
)

export default ChooseTheProficiencyLevelSlide
